import { Component, Input, ViewEncapsulation } from "@angular/core";
import { Staff } from "@common/data-models/service/staff";

@Component({
    selector: 'staff-id-list-tooltip',
    templateUrl: './staff-id-list-tooltip.html',
    styleUrls: ['./staff-id-list-tooltip.scss'],
    encapsulation: ViewEncapsulation.None,
    // changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        'class': 'st-staff-id-list-tooltip'
    }
})

export class StaffIDListTooltip {
    @Input() public users: Staff[];
}
